import { createFileRoute } from "@tanstack/react-router";
import AnxietyTurnsIntoDepressionFoundersGuide from "@/pages/articles/AnxietyTurnsIntoDepressionFoundersGuide";
export const Route = createFileRoute(
  "/when-anxiety-turns-into-depression-a-guide-for-founders-and-executives",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Anxiety to Depression for Founders | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "When anxiety turns into depression: a guide for founders and executives. Learn about TMS and SAINT TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Anxiety to Depression for Founders | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "When anxiety turns into depression: a guide for founders and executives. Learn about TMS and SAINT TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/when-anxiety-turns-into-depression-a-guide-for-founders-and-executives",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/when-anxiety-turns-into-depression-a-guide-for-founders-and-executives",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AnxietyTurnsIntoDepressionFoundersGuide />;
}
